/**
 * Utility to extract the TLD from a host string
 *
 * @param {string} host
 * @return {String}
 */
module.exports = function extractTldFromHost(host){
  return host.split('.').pop();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/tldjs/lib/from-host.js
// module id = 83
// module chunks = 0